export function scrollGradientInit() {
    let gradientContainers = document.querySelectorAll('.container-gradient');

    for (let i = 0; i < gradientContainers.length; i++) {
        let scrollContainer = gradientContainers[i].querySelector('.container-scroll');
        scrollContainer.addEventListener('scroll', function() {
            // Hide gradient when we're scrolled to within 10px of the right edge of the container
            if (scrollContainer.scrollWidth - scrollContainer.scrollLeft - scrollContainer.clientWidth < 10) {
                gradientContainers[i].classList.add('gradient-hidden');
            }
            else {
                gradientContainers[i].classList.remove('gradient-hidden');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/scroll-gradient.js